import { FGTextInput, FieldGroup } from "nsitools-react";
import * as React from "react";

import { DnaMarkerResultDto, DogDnaApi } from "../../../../../api";
import { SmallFormGenerator } from "../../../../../components";
import { useApiService, useCrudApi, useTl } from "../../../../../hooks";
import { ETLCodes } from "../../../../../locales";

export interface IDnaMarkerEditProps {
  dnaMarkerResultId: number;
  onSave: () => void;
}

export const DnaMarkerEdit: React.FunctionComponent<IDnaMarkerEditProps> = ({ dnaMarkerResultId, onSave }) => {
  const { t } = useTl();
  const api = useApiService(DogDnaApi);
  const save = React.useCallback(
    async (d: DnaMarkerResultDto) => {
      var res = await api.saveDnaMarkerResult(d);
      onSave();
      return res;
    },
    [api, onSave]
  );
  const { data, loading, saving, saveItem } = useCrudApi(
    {
      getApiFn: () => api.getDnaMarkerResult(dnaMarkerResultId),
      saveApiFn: (d) => save(d),
      deleteApiFn: (d) => {},
    },
    []
  );

  return (
    <div style={{ marginRight: "1rem", marginTop: "1rem" }}>
      <SmallFormGenerator
        initialValues={data}
        onSubmit={saveItem}
        editMode={true}
        loading={loading}
        showDeleteButton={false}
        saving={saving}
        minLabelWidth={100}
      >
        <FieldGroup>
          <FGTextInput name="marker" label={t(ETLCodes.Marker)} readonly />
          <FGTextInput name="value1" label={t(ETLCodes.Value1)} />
          <FGTextInput name="value2" label={t(ETLCodes.Value2)} />
        </FieldGroup>
      </SmallFormGenerator>
    </div>
  );
};
